import { Box, Flex, Text } from '@chakra-ui/react';
import { faCircleCheck, faDownload } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@morressier/alembic';
import { IAuthorCopyrightForm } from '@publishing-engine/domain/models';
import { useState } from 'react';
import { formatDate } from 'src/utils/date';
import { downloadFile } from 'src/utils/file';

interface Props {
  organizationName?: string;
  submittingAuthorOnlyCopyrightForm: IAuthorCopyrightForm | undefined;
}
export const SubmittingAuthorOnlyCopyrightFormSubmitted: React.FC<Props> = ({
  organizationName,
  submittingAuthorOnlyCopyrightForm
}) => {
  const DownloadAgreementButton = () => {
    const [isFileDownloading, setIsFileDownloading] = useState(false);

    const handleFileDownload = async (fileUrl: string) => {
      try {
        setIsFileDownloading(true); // disable button
        await downloadFile(fileUrl);
      } finally {
        setIsFileDownloading(false); // re-enable no matter what
      }
    };

    return (
      <Button
        onClick={() => {
          if (submittingAuthorOnlyCopyrightForm?.file?.url) {
            handleFileDownload(submittingAuthorOnlyCopyrightForm.file.url);
          }
        }}
        leftIcon={<FontAwesomeIcon icon={faDownload} />}
        isDisabled={
          isFileDownloading || !submittingAuthorOnlyCopyrightForm?.file?.url
        }
        isLoading={isFileDownloading}
        variant="secondary"
      >
        Download Agreement
      </Button>
    );
  };
  return (
    submittingAuthorOnlyCopyrightForm && (
      <Box>
        <Flex flexDirection="column" gap={8}>
          <Flex flexDirection="column" gap={2}>
            <Text textStyle="headingSection">
              Copyright and Publication Agreement
            </Text>
          </Flex>
          <Flex
            height="112px"
            width="100%"
            background="successSecondaryFill"
            justifyContent="center"
            alignItems="center"
            borderRadius="base"
            color="successPrimaryContentAccent"
            marginBottom={8}
          >
            <FontAwesomeIcon fontSize={40} icon={faCircleCheck} />
          </Flex>
        </Flex>
        <Flex flexDirection="column" gap={2}>
          <Text textStyle="headingTitle">
            Copyright and Publication Agreement Submitted
          </Text>
          <Text textStyle="textBody">
            {`You have successfully submitted a Copyright and Publication Agreement for this submission to ${organizationName} on ${formatDate(
              new Date(submittingAuthorOnlyCopyrightForm.date)
            )}. You can now download a copy of the form.`}
          </Text>
        </Flex>
        <Flex justifyContent="flex-start" mt={8}>
          <DownloadAgreementButton />
        </Flex>
      </Box>
    )
  );
};
